import { createApp } from '@app/adapters/create-app'
import SfAssistantChecksBanner from '@app/application/sf-assistant-checks/components/sf-assistant-checks-banner'

onDomLoad(function () {
  const banner = document.querySelector(
    '[data-behaviour="sf-assistant-banner"]'
  )

  if (banner) {
    createApp(
      SfAssistantChecksBanner,
      {},
      {
        singletonId: 'sf-assistant-checks-banner',
      }
    ).mount(banner)
  }
})
